import { render, staticRenderFns } from "./school-follow.vue?vue&type=template&id=090ea800&scoped=true&"
import script from "./school-follow.vue?vue&type=script&lang=js&"
export * from "./school-follow.vue?vue&type=script&lang=js&"
import style0 from "./school-follow.vue?vue&type=style&index=0&id=090ea800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ea800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090ea800')) {
      api.createRecord('090ea800', component.options)
    } else {
      api.reload('090ea800', component.options)
    }
    module.hot.accept("./school-follow.vue?vue&type=template&id=090ea800&scoped=true&", function () {
      api.rerender('090ea800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/count/school-follow.vue"
export default component.exports